import { render, staticRenderFns } from "./customPrimarySlider.vue?vue&type=template&id=7052be31"
import script from "./customPrimarySlider.vue?vue&type=script&lang=js"
export * from "./customPrimarySlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports